import { z } from 'zod';
import { EmailSchema, HistoryEntrySchema, IDSchema, IsoTimestampSchema, SchemaVersionSchema, } from './shared.js';
export const MeetingStateSchema = z.enum(['scheduled', 'completed', 'canceled', 'no_show']);
export const AttendeeSchema = z.object({
    email: EmailSchema,
    name: z.string(),
    role: z.enum(['rep', 'customer', 'cindy', 'observer']),
});
export const MeetingSchema = z.object({
    id: IDSchema,
    type: z.literal('meeting'),
    schemaVersion: SchemaVersionSchema,
    accountId: IDSchema,
    scheduledByRepEmail: EmailSchema,
    scheduledByRepName: z.string(),
    scheduledAt: IsoTimestampSchema,
    meetingStartUtc: IsoTimestampSchema,
    meetingEndUtc: IsoTimestampSchema,
    customerTimezone: z.string(),
    attendees: z.array(AttendeeSchema).default([]),
    hasTeamsLink: z.boolean().default(false),
    teamsLinkUrl: z.string().url().optional(),
    outlookEventId: z.string(),
    outlookICalUid: z.string().optional(),
    state: MeetingStateSchema,
    stateChangedAt: IsoTimestampSchema,
    stateChangedBy: z.string(),
    cancelReason: z.string().optional(),
    /** 2026-11-04 trust review — the title the rep gave it (the invite subject). */
    title: z.string().optional(),
    preNotes: z.string().optional(),
    postNotes: z.string().optional(),
    // RIG-336 — uses the shared HistoryEntrySchema (payload omitted: this entity
    // intentionally does not record structured history payloads).
    history: z.array(HistoryEntrySchema.omit({ payload: true })).default([]),
    createdAt: IsoTimestampSchema,
    createdBy: z.string(),
    updatedAt: IsoTimestampSchema,
    updatedBy: z.string(),
    deletedAt: IsoTimestampSchema.nullable().optional(),
    version: z.number().int().positive(),
});
//# sourceMappingURL=meeting.js.map